{
  "GENERAL": {
    "CLOSE": "Zatvori",
    "SHOWING_RESULTS": "Prikaz {firstIndex}-{lastIndex} od {totalCount} stavki",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Pretraži",
      "EMPTY_STATE": "Nisu pronađeni rezultati"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Potrebno najmanje {count}"
  }
}
